import React from 'react';

import TextAreaField from 'components/common/TextAreaField';
import {
  TASKS_GRID_NOTES_FIELD_LABEL,
  TASKS_GRID_NOTES_PLACEHOLDER,
} from 'constants/uiConstants';
import { TASK_NOTES_MAX_LENGTH } from 'constants/validationConstants';
import type { GUnit } from 'interfaces/IGlobalCatalogue';
import type { IInputTask, IInputTaskBase } from 'interfaces/IInputTask';

import { getTaskDetailFieldState } from './taskDetailFields';
import { ApplicationTaskFields } from './taskFactory';
import { ClearFieldButton } from './TaskInlineDetails';

interface TaskDetailsSectionProps {
  task: IInputTask;
  gUnits: GUnit[];
  fieldVisibilityOverride: Map<string, boolean>;
  commitTaskField: (
    task: IInputTask,
    patch: Partial<IInputTaskBase & ApplicationTaskFields>
  ) => void;
}

// An expanded task's Notes, on their own full-width line under the task row
// (OP-2534). Water rate and Target, and the Notes button itself, sit on the
// task row (TaskInlineDetails); nothing renders here while Notes is hidden.
const TaskDetailsSection: React.FC<TaskDetailsSectionProps> = ({
  task,
  gUnits,
  fieldVisibilityOverride,
  commitTaskField,
}) => {
  const { showNotes, hasNotes } = getTaskDetailFieldState(
    task,
    gUnits,
    fieldVisibilityOverride
  );
  if (!showNotes) return null;

  return (
    <div className="border-l-2 border-success-dark px-2 pt-2">
      <div className="flex items-start gap-1">
        <div className="min-w-0 flex-1">
          <TextAreaField
            label={TASKS_GRID_NOTES_FIELD_LABEL}
            inputClassName="w-full flex-1 bg-white"
            rows={2}
            value={task.notes}
            placeholder={TASKS_GRID_NOTES_PLACEHOLDER}
            maxLength={TASK_NOTES_MAX_LENGTH}
            onCommit={(notes) => commitTaskField(task, { notes })}
          />
        </div>
        {hasNotes && (
          <ClearFieldButton
            label={TASKS_GRID_NOTES_FIELD_LABEL}
            onClear={() => commitTaskField(task, { notes: null })}
          />
        )}
      </div>
    </div>
  );
};

export default TaskDetailsSection;
